import FormattedText from './FormattedText';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { MdInfoOutline } from 'react-icons/md';

export default function PortalFieldHelp({ label, children }) {
  return (
    <Tooltip
      title={<FormattedText>{children}</FormattedText>}
      placement="top"
      arrow
      enterTouchDelay={0}
      classes={{ tooltip: 'portal-field-tooltip' }}
    >
      <span
        role="button"
        tabIndex={0}
        className="portal-field-help hidethis"
        aria-label={`Sobre ${label}`}
        onClick={(event) => event.preventDefault()}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') event.preventDefault();
        }}
      >
        <MdInfoOutline aria-hidden="true" />
      </span>
    </Tooltip>
  );
}
